;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import moment, { Moment } from "moment-timezone"

const guessAndCastDateTimeToLocal = (
  dateTime: string | number | Date | null | undefined,
): Moment => {
  const guessedTimezone = moment.tz.guess()
  const utcTime = moment.utc(dateTime)
  return utcTime.tz(guessedTimezone)
}

export default guessAndCastDateTimeToLocal
